import { handleResponseError } from '@/Helpers.js';
import FeatureAccessApi from '@/services/FeatureAccessApi.js';
import { buildAccessDeniedLocation } from '@/utilities/accessDeniedLocation.js';

/**
 * Creates a Vue Router `beforeEnter` guard that re-checks feature access live
 * on the backend (ADR-036 Phase 3) instead of trusting the `user.features`
 * array from initial-state hydration, which reflects access at login time
 * and goes stale the moment a rule or role changes mid-session.
 *
 * On request failure, navigation is allowed through (matching the
 * fail-open + handleResponseError pattern in CheckQuizAttempt.js) since the
 * backend's own EnsureFeatureAccess middleware remains the authoritative
 * gate for the feature's actual API calls; this guard only protects the
 * route shell.
 */
export default function FeatureMiddleware(featureName) {
    /**
     * Redirect a confirmed denial; let the API enforce access if the live check fails.
     */
    return async function createFeatureMiddleware(to, from, next) {
        try {
            const hasFeature = await FeatureAccessApi.check(featureName);

            if (!hasFeature) {
                return next(buildAccessDeniedLocation(to, from));
            }
        } catch (error) {
            handleResponseError(error);
        }

        return next();
    };
}
